<div class="container">
  <ghs-header [standalone]="true"></ghs-header>

  <div class="menu">
    <label>
      <span [ghs-label]="'settings.edition'"></span>
      <select [(ngModel)]="edition" (change)="update(); updateQueryParams()">
        <option *ngFor="let edition of gameManager.editions(true)" [value]="edition">
          <span [ghs-label]="'data.edition.' + edition"></span>
        </option>
      </select>
    </label>
  </div>

  <div class="sections" *ngIf="edition">
    <div class="section" *ngFor="let section of sections">
      <ghs-random-monster-card [section]="section" [flipped]="true"></ghs-random-monster-card>
    </div>
  </div>
</div>